import { Injectable } from '@angular/core';
import { ConfigService } from '../../config.service';
import { AuthorizationData } from 'fl-platform-authorizer';
import {
  TokenService as LibraryTokenService,
  createTokenService,
  DataModel,
} from 'qp-storefront';
import { LocalStorageService } from '../../storage/local-storage.service';
import { KEYS } from 'src/app/shared/utils/constants/storage.constants';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private tokenService: LibraryTokenService | undefined;
  constructor(
    private configService: ConfigService,
    private localStorageService: LocalStorageService
  ) {}

  public fetchOvatToken(
    deviceId: string,
    deviceName: string,
    authData?: AuthorizationData
  ): Promise<DataModel> {
    let accessToken =
      this.localStorageService.getItem(KEYS.PLATFORM_TOKEN) || '';
    if (authData) {
      accessToken = authData.accessToken;
    }
    if (!this.tokenService) {
      this.tokenService = createTokenService(
        this.configService.applicationConfig.guestFlatURL
      );
    }
    return this.tokenService.getOvatToken(deviceId, deviceName, accessToken);
  }
}
